import React, { useState, useEffect } from "react";
import axios from 'axios';
import "../../css/dashboard.css";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

function PublicDetail(props) {

    const location = useLocation();
    const navigate = useNavigate();

    const [reserve, setReserve] = useState({});

    const [memo, setMemo] = useState('');

    const saveMemo = async () => {
        try {
            await axios.put(`/ReservationPublic/Memo/${location.state.idx}`, { memo });
        } catch (error) {
            console.error('Error saving memo:', error);
            alert('메모 저장 중 오류가 발생했습니다.');
        }
    };

    const startBeforePage = async () => {
        await saveMemo(); // 목록으로 나가기 전에 저장
        if (location.state && location.state.beforePage) {
            navigate(location.state.beforePage);
        } else {
            navigate(-1);
        }
    }

    const goToQuotation = () => {
        navigate('/quotation', { state: { ...location.state, reserveData: reserve } });
    }

    useEffect(() => {
        const getReservationDetail = async () => {
            try {
                const reserve_result = await axios.get(`/ReservationPublic/ReservationId/${location.state.idx}`);
                setReserve(reserve_result.data[0]);
                setMemo(reserve_result.data[0].memo || '');
            } catch (error) {
                console.error('Error fetching reservation count:', error.message);
            }
        };
        getReservationDetail();
    }, [location.state.idx]);

    return (
        <PageContainer>
            <Card>
                <CardHeader>
                    <Title>대량주문/문의 상세</Title>
                </CardHeader>

                <SectionTitle>업체 및 담당자 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="회사이름" value={reserve.company} />
                    <InfoItem label="담당자 이름" value={reserve.name} />
                    <InfoItem label="전화번호" value={reserve.phone1} />
                    <InfoItem label="이메일" value={reserve.phone2} />
                    <InfoItem label="주소" value={reserve.address} span={4} />
                </GridContainer>

                <SectionTitle>에어컨 수량 정보</SectionTitle>
                <GridContainer>
                    <InfoItem label="벽걸이" value={reserve.aircon1} />
                    <InfoItem label="가정용 스탠드" value={reserve.aircon2} />
                    <InfoItem label="천정형 1-Way" value={reserve.aircon4} />
                    <InfoItem label="천정형 2-Way" value={reserve.aircon5} />
                    <InfoItem label="천정형 4-Way" value={reserve.aircon6} />
                    <InfoItem label="천정형 원형" value={reserve.aircon7} />
                    <InfoItem label="중대형,업소용" value={reserve.aircon9} />
                    <InfoItem label="실외기" value={reserve.aircon8} />
                </GridContainer>

                <SectionTitle>계약 및 예산</SectionTitle>
                <GridContainer>
                    <InfoItem label="계약방법" value={reserve.reserve_kind} span={2} />
                    <InfoItem label="회사예산" value={reserve.budget ? Number(reserve.budget).toLocaleString() + '원' : '-'} span={2} isHighlight />
                </GridContainer>

                <SectionTitle>메모</SectionTitle>
                <div style={{ padding: '0 10px' }}>
                    <StyledTextarea
                        value={memo}
                        onChange={(e) => setMemo(e.target.value)}
                        placeholder="통화 내용이나 특이사항을 입력하세요."
                    />
                </div>

                <ButtonGroup>
                    <OutlineButton onClick={goToQuotation}>견적서작성</OutlineButton>
                    <OutlineButton onClick={startBeforePage}>확인</OutlineButton>
                </ButtonGroup>
            </Card>
        </PageContainer>
    )
}

// --- Helper Components ---
const InfoItem = ({ label, value, span = 1, isHighlight }) => (
    <div style={{ gridColumn: `span ${span}`, display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <Label>{label}</Label>
        <Value isHighlight={isHighlight}>{value || '-'}</Value>
    </div>
);

// --- Styled Components (80% Compact Version) ---

const PageContainer = styled.div`
    padding: 20px;
    background-color: #f5f6f8;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 40px;
    box-sizing: border-box;
`;

const Card = styled.div`
    background: white;
    width: 100%;
    max-width: 1000px;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    padding: 32px 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const CardHeader = styled.div`
    border-bottom: 1px solid #eee;
    padding-bottom: 12px;
    margin-bottom: 8px;
`;

const Title = styled.h2`
    font-size: 1.5rem;
    color: #111;
    margin: 0;
    font-weight: 800;
`;

const SectionTitle = styled.h3`
    font-size: 1.1rem;
    color: #333;
    margin: 0 0 10px 0;
    border-left: 4px solid #006edc;
    padding-left: 10px;
`;

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;
    row-gap: 16px;
    
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
    }
`;

const Label = styled.div`
    font-size: 0.8rem;
    color: #888;
    font-weight: 500;
    margin-bottom: 3px;
`;

const Value = styled.div`
    font-size: 0.95rem;
    color: ${props => props.isHighlight ? '#d32f2f' : '#222'};
    font-weight: ${props => props.isHighlight ? 'bold' : 'normal'};
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 5px;
    min-height: 22px;
    word-break: break-all;
`;

const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
`;

const BaseButton = styled.button`
    padding: 8px 18px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    font-size: 0.9rem;
`;

const OutlineButton = styled(BaseButton)`
    background-color: white;
    border: 1px solid #ccc;
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

const StyledTextarea = styled.textarea`
    width: 100%;
    height: 150px;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    resize: vertical;
    font-size: 0.95rem;
    font-family: inherit;
    box-sizing: border-box;
    &:focus {
        border-color: #006edc;
        outline: none;
    }
`;

export default PublicDetail;